import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BACKEND_URL } from "../../../config/config";
import { Button, ButtonLink } from "../../misc/button/Button";
import { Form, Input, Spin } from "antd";
import { NotificationContext } from "../../context/NotificationWrapper";
import SpinLoading from "../../misc/loading/SpinLoading";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const styles = {
  blocInput: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    marginBottom: "20px",
  },
  blocButton: {
    width: "250px",
    marginTop: "30px",
    display: "flex",
    justifyContent: "space-between",
  },
};

function ChangeEmail() {
  const navigate = useNavigate();
  const { openNotification } = useContext(NotificationContext);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = (values) => {
    setIsLoading(true);
    const requestBody = {
      email: values.email1,
    };
    axios
      .post(`${BACKEND_URL}/api/register/change/email`, requestBody, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        setIsLoading(false);
        openNotification(
          "Finaliser le changement d'e-mail",
          "Nous avons envoyé un e-mail à votre nouvelle adresse avec un lien de confirmation.",
          "success"
        );
        navigate("/infoIdentifier");
      })
      .catch((error) => {
        setIsLoading(false);
        openNotification("Erreur", error.response.data.data, "error");
        console.error("error", error);
      });
  };

  return (
    <>
      <Spin spinning={isLoading} fullscreen />
      <div className="info-detail update-page">
        <h2>Modification de l'email</h2>
        <div className="form-update-page">
          <Form
            {...formItemLayout}
            form={form}
            name="changeEmail"
            onFinish={onFinish}
            style={styles.form}
            scrollToFirstError
          >
            <Form.Item
              name="email1"
              label="Nouvelle adresse e-mail"
              style={styles.input}
              rules={[
                {
                  type: "email",
                  message: "Ce n'est pas une adresse e-mail valide",
                },
                {
                  required: true,
                  message: "Veuillez entrer votre e-mail",
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="email2"
              label="Confirmez la nouvelle adresse"
              style={styles.input}
              dependencies={["email1"]}
              hasFeedback
              rules={[
                {
                  type: "email",
                  message: "Ce n'est pas une adresse e-mail valide",
                },
                {
                  required: true,
                  message: "Veuillez confirmer votre e-mail",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("email1") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Les deux e-mails ne correspondent pas")
                    );
                  },
                }),
              ]}
            >
              <Input />
            </Form.Item>
            <div style={styles.blocButton}>
              <div>
                <ButtonLink to="/infoIdentifier" text="Retour">
                  Retour
                </ButtonLink>
              </div>
              <Form.Item>
                <Button
                  type="submit"
                  children={isLoading ? <SpinLoading /> : "Valider"}
                />
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}

export default ChangeEmail;
